<div class="close-button tw:mt-4">
  <pnkl-modal-close-btn (click)="closeModal()"></pnkl-modal-close-btn>
</div>

<form [formGroup]="searchForm">
  <input
    #searchField
    formControlName="searchField"
    placeholder="Type to search"
    tabindex="0"
    type="search"
  />
</form>

<pnkl-tab-selector
  (itemSelected)="itemSelected($any($event))"
  [tabList]="tabList"
>
  <ng-container tab-content="">
    @if (isLoading()) {
      <div class="search-info-text">Loading...</div>
      <div class="wide-search-loader"></div>
    } @else {
      @if (searchFieldIsEmpty()) {
        <div class="search-info-text">Nothing to display, start typing...</div>
      } @else {
        @if (securityList().length === 0) {
          <div class="search-info-text">
            No data was found for the combination of search text and selected filter ;(
          </div>
        }
        @if (securityList().length > 0) {
          <div class="security-items-wrapper">
            <pnkl-security-items
              #securityItemsList
              (itemClicked)="itemClicked($event)"
              [items]="securityList()"
              [searchText]="searchForm.controls.searchField.value"
            >
            </pnkl-security-items>
          </div>
        }
      }
    }
  </ng-container>
</pnkl-tab-selector>
